import type { Dispatch } from 'react';

import { User } from '../../services/types';

export interface ContextValue {
  state: State;
  dispatch: (callback: (state: State, dispatch: Dispatch<ActionPayload>) => void) => void;
}

export interface State {
  user: User | null;
}

export enum ActionType {
  SET_USER = 'SET_USER',
}

export type ActionPayload = {
  type: ActionType.SET_USER;
  payload: { user: User | null };
};
